module.exports = __webpack_public_path__ + "static/media/4k monitor support for InfraWorks.1ac2712d.png";